"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var BANKGIRO_REGEXP_HYPHEN = /^\d{3,4}[-]?\d{4}$/;
exports.bankgiroValidator = {
    name: 'bankgiro',
    formatter: function (value) {
        /**
         * Add a hyphen if there is no hyphen. The hyphen should be placed before the last 4 digits.
         */
        if ((value.length === 7 || value.length === 8) && !value.includes('-')) {
            return value.substring(0, value.length - 4) + '-' + value.substring(value.length - 4, value.length);
        }
        return value;
    },
    validation: function (value) {
        return utils_1.isEmpty(value) || (BANKGIRO_REGEXP_HYPHEN.test(value) && utils_1.testLuhnChecksum(value.replace(/-/g, '')));
    },
};
//# sourceMappingURL=BankgiroValidator.js.map